import { EntryListContent } from '@/api/interfaces/content/common/entryListContent';

export const enumsContent: EntryListContent = {
    connectionRulesType: {
        rules4105: 'VDE AR N 4105',
        rules4110: 'VDE AR N 4110',
        unknown: 'Unbekannt',
    },
    events: {
        applicationCreated:
            "{{ isDefined('originalApplicationId') ? `Antrag als Kopie erstellt. Original-ID: <strong>${originalApplicationId}</strong>.` : 'Antrag erstellt.' }}",
        applicationCopied:
            'Antrag kopiert. Neue Id: <strong>{{copyTargetApplicationId}}</strong>.',
        applicationDeleted:
            'Antrag gelöscht (<strong>{{type}}</strong>). Auslöser: <strong>{{trigger}}</strong>.',
        applicationStatusControllerCalled:
            "ApplicationStatusController wurde aufgerufen.{{ isDefined('request') ? ': ' + serializeObjectFormatted(request) : '' }}",
        applicationStatusChanged:
            'Status zu <strong>{{statusTranslated}}</strong> geändert.',
        applicationNumberChanged:
            'Antragsnummer zu <strong>{{applicationNumber}}</strong> geändert.',
        applicationCompletedDateChanged:
            'Datum <em>Antrag vollständig</em> zu <strong>{{completedDate}}</strong> geändert.',
        applicationDataMigrated:
            'Datenversion migriert von <strong>{{versionBeforeMigration}}</strong> zu <strong>{{versionAfterMigration}}</strong>',
        deletedObsoleteUserUploadedFiles:
            'Es wurden <strong>{{result.totalFiles}}</strong> Dateien mit einer Gesamtgröße von <strong>{{readableFileSize(result.totalFileSize)}}</strong> gelöscht.',
        deaDbApi:
            "Dea DB API wurde aufgerufen: <strong>{{requestType}}</strong> -> <strong>{{result}}</strong>{{ isDefined('message') ? ': ' + serializeObjectFormatted(message) : '' }}",
        mailSent:
            'Mail wurde versendet: <strong>{{subType}}</strong> ("<strong>{{emailModelDisplayName}}</strong>")',
    },
    plantType: {
        emergencyGenerator: '',
        fuelCell: 'Brennstoffzelle',
        gasTurbine: 'Gasturbine',
        hydroPowerPlant: 'Wasserkraftanlage',
        orcPowerPlant: 'ORC-Anlage',
        photovoltaicPowerPlant: 'Solaranlage',
        photovoltaicPowerPlantAndStorageLte30:
            'Solaranlage + Speicher bis 30 kW',
        steamTurbine: 'Wasserdampfturbine',
        stirlingEngine: 'Stirling-Motor',
        storage: 'Speicher',
        thermalPowerPlantDea: 'Blockheizkraftwerk',
        thermalPowerPlantKwk: 'Blockheizkraftwerk',
        windPowerPlant: 'Windenergieanlage',
    },
    technology: {
        bio: 'Bio',
        emergencyGenerator: 'Notstromaggregat > 100 ms',
        fuelCell: 'Brennstoffzelle',
        gasTurbine: 'Gasturbine',
        hydroPowerPlant: 'Wasserkraftanlage',
        orcPowerPlant: 'ORC-Anlage',
        photovoltaicPowerPlant: 'Solaranlage',
        photovoltaicPowerPlantAndStorageLte30:
            'Solaranlage + Speicher bis 30 kW',
        steamTurbine: 'Wasserdampfturbine',
        stirlingEngine: 'Stirling-Motor',
        storage: 'Speicher',
        thermalPowerPlantDea: 'Blockheizkraftwerk',
        thermalPowerPlantKwk: 'Blockheizkraftwerk',
        windPowerPlant: 'Windenergieanlage',
    },
};
